import React from 'react';
import { Grid, FormControlLabel, Checkbox, TextField, FormHelperText } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const ConsentOrders = ({ formData, setFormData, handleChange, validationErrors }) => {
  const isMinor = parseInt(formData.age) < 18;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="surgicalConsent" checked={formData.surgicalConsent} onChange={handleChange} />}
          label="Surgical Consent"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="highRiskConsent" checked={formData.highRiskConsent} onChange={handleChange} />}
          label="High Risk Consent"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="bloodTransfusionConsent" checked={formData.bloodTransfusionConsent} onChange={handleChange} />}
          label="Blood Transfusion Consent"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={<Checkbox name="anesthesiaConsent" checked={formData.anesthesiaConsent} onChange={handleChange} />}
          label="Anesthesia Consent"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="guardianName"
          label={isMinor ? "Legal Guardian Name *" : "Legal Guardian Name"}
          value={formData.guardianName || ''}
          onChange={handleChange}
          fullWidth
          required={isMinor}
          error={!!validationErrors.guardianName}
          helperText={validationErrors.guardianName || (isMinor ? "Required for patients under 18" : "")}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PhoneInput
          country={'in'}
          value={formData.guardianContact || ''}
          onChange={(value) => setFormData((prev) => ({ ...prev, guardianContact: value }))}
          enableSearch
          inputProps={{
            name: 'guardianContact',
            required: isMinor,
            autoFocus: false,
          }}
          containerStyle={{ width: '100%' }}
          inputStyle={{
            width: '100%',
            height: '56px',
            borderColor: validationErrors.guardianContact ? '#f44336' : undefined
          }}
          buttonStyle={{ height: '56px' }}
        />
        {validationErrors.guardianContact && (
          <FormHelperText error>{validationErrors.guardianContact}</FormHelperText>
        )}
        {isMinor && (
          <FormHelperText>Required for patients under 18</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="consentComments"
          label="Consent Comments"
          value={formData.consentComments || ''}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
    </Grid>
  );
};

export default ConsentOrders;
